import { render, staticRenderFns } from "./system_logs.vue?vue&type=template&id=5495de56&scoped=true&"
import script from "./system_logs.vue?vue&type=script&lang=js&"
export * from "./system_logs.vue?vue&type=script&lang=js&"
import style0 from "./system_logs.vue?vue&type=style&index=0&id=5495de56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495de56",
  null
  
)

export default component.exports